import {
	ReadonlyRefObject,
	useLayoutEffect,
	useState
} from "react";
import { useResizeObserver } from "./useResizeObserver";
import { isNotNil } from "client/Misc/utils";

type Dimensions = {
	height: number;
	width: number;
};

export type ScaleToFitResult = {
	scale: number;
	scaledDimensions: Dimensions;
};

export function useScaleToFit(
	ref: ReadonlyRefObject<HTMLElement | null>,
	containerWidth: number,
	containerHeight?: number
): ScaleToFitResult | null {

	const [scaledDimensions, setScaledDimensions] = useState<ScaleToFitResult | null>(null);

	const {
		width: contentWidth,
		height: contentHeight,
		wasInitialized
	} = useResizeObserver(ref);

	useLayoutEffect(
		(): void => {
			if (!wasInitialized) {
				return;
			}

			const scaleWidth: number = contentWidth > 0
				? Math.min(containerWidth / contentWidth, 1)
				: 0;

			const scaleHeight: number = isNotNil(containerHeight)
				? contentHeight > 0
					? Math.min(containerHeight / contentHeight, 1)
					: 0
				: 1;

			const scale: number = Math.min(scaleWidth, scaleHeight);
			const height: number = contentHeight * scale;
			const width: number = contentWidth * scale;

			setScaledDimensions({
				scale,
				scaledDimensions: {
					height,
					width
				}
			});
		},
		[
			containerWidth,
			containerHeight,
			contentHeight,
			contentWidth,
			wasInitialized
		]
	);

	return scaledDimensions;
}